import FlatTable, { flatValue } from "../../../../../../Components/common/FlatTable/FlatTable";
import CrimeDetailsView from "./CrimeDetailsView";
import { EVIDENCE_LEGEND, crimeHasDetails } from "./crimesUtils";

import "./flatStyles.scss";

// html2canvas rasterizes the whole DOM at scale 2, so an unbounded list runs it
// out of memory on a busy report. The JSON and CSV exports carry the full set,
// so nothing is lost.
const MAX_CRIMES = 50;
const MAX_CRIME_DETAILS = 10;
const MAX_LOCATIONS_PER_CRIME = 5;
const MAX_CHAIN_STEPS = 6;

const columns = [
  {
    label: "Description",
    render: (row) => flatValue(row?.crime),
    className: "android-crimes-flat__description",
  },
  { label: "Score", render: (row) => flatValue(row?.score) },
  { label: "Confidence", render: (row) => flatValue(row?.confidence) },
  { label: "Weight", render: (row) => flatValue(row?.weight) },
];

// Stateless counterpart of Crimes.js: no pagination and no expand rows, so
// every row prints and the details print underneath instead of staying behind
// a click. The raw smali call sites are left out here — they are the bulk of
// the volume and the report is meant to stay compact.
const CrimesFlat = ({ data }) => {
  const rows = Array.isArray(data) ? data : [];
  const withDetails = rows.filter(crimeHasDetails);
  const visibleDetails = withDetails.slice(0, MAX_CRIME_DETAILS);

  return (
    <div className="android-crimes-flat">
      <FlatTable
        columns={columns}
        data={rows}
        maxRows={MAX_CRIMES}
        moreLabel="actions"
        emptyMessage="No possible malicious actions found"
      />

      {visibleDetails.length > 0 ? (
        <div className="android-crimes-flat__details">
          <h3 className="android-crimes-flat__details-title">Action Details</h3>
          <p className="android-crimes-flat__legend">{EVIDENCE_LEGEND}</p>

          {visibleDetails.map((crime, index) => (
            <div className="android-crimes-flat__detail" key={index}>
              <h4 className="android-crimes-flat__detail-name">{flatValue(crime?.crime)}</h4>
              <CrimeDetailsView
                crime={crime}
                maxLocations={MAX_LOCATIONS_PER_CRIME}
                maxChainSteps={MAX_CHAIN_STEPS}
              />
            </div>
          ))}

          {withDetails.length > MAX_CRIME_DETAILS ? (
            <p className="android-crimes-flat__more">
              +{withDetails.length - MAX_CRIME_DETAILS} more actions with details — see the CSV
              export for the full list
            </p>
          ) : null}
        </div>
      ) : null}
    </div>
  );
};

export default CrimesFlat;
